import { handleStatus500 } from 'api/Utility/HandleStatus500'
import { ASC, COLUMNS } from 'lib/GlobalConstants'
import AxiosInitializer from 'api/Utility/AxiosInitializer'
import getToken from 'lib/authentication/GetToken'

export const fetchProjects = async () => {
  try {
    const axios = AxiosInitializer({ token: getToken() })

    const query = {
      fields: {
        project: ['name', 'created-at'],
      },
      sort: COLUMNS.createdAt,
      per_page: 999,
      order: ASC,
      filterable: true,
      assigned: true,
    }

    const response = await axios.get('/projects', {
      params: query,
    })

    return response.data.data
  } catch (error: any) {
    return handleStatus500(error)
  }
}
